import React from 'react'
import { required, SelectInput, SelectInputProps } from 'react-admin'
// import { ADMINS_FIELDS } from '../../../providers/localization/constant'

const defaultProps = {
  label: 'ประเภท',
  source: 'type',
  choices: [
    { id: 'n', name:'news' },
    { id: 'b', name: 'blog' },
  ],
}

export const NewsBlogSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  defaultValue,
  ...props
}) => {
  return (
    <SelectInput
      margin='dense'
      fullWidth
      label={label}
      source={source}
      choices={choices}
      validate={[required()]}
      defaultValue={defaultValue}
      {...props}
    />
  )
}

NewsBlogSelectInput.defaultProps = defaultProps
